module.exports = __webpack_public_path__ + "img/bottom2.4104249d.png";